import api from './api';
import { API_BASE } from '../config';

const BASE = API_BASE && API_BASE.endsWith('/index.php') ? API_BASE : `${API_BASE}/index.php`;
const API_URL = `${BASE}/budget`;

export const getOneri = async (cantiereId) => {
    const res = await api.get(`${API_URL}/oneri/${cantiereId}`);
    return res.data;
};

export const saveOneri = async (cantiereId, dati) => {
    const res = await api.post(`${API_URL}/oneri/${cantiereId}`, dati);
    return res.data;
};